import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BannerType } from '@enums';
import { BannerMessage } from '@model';

@Component({
    selector: 'app-system-message',
    templateUrl: './system-message.component.html',
    standalone: false
})
export class SystemMessageComponent implements OnInit {
  @Input()
  id: number
  @Input()
  message: string;
  @Input()
  severity: number;
  @Input()
  icon: string;
  @Input()
  isVisible: boolean;
  @Input()
  isDismissable: boolean = true;
  @Input()
  type: BannerType = BannerType.System;

  @Output()
  messageDismissed = new EventEmitter<number>();

  bannerTypeEnum = BannerType;

  constructor() { }

  ngOnInit(): void {
    //console.log(`system-message\ticon`, { message: this.message, content: this.content, icon:  this.icon});
  }

  onDismissed(){
    this.messageDismissed.emit(this.id);
  }
}
